import React, { useEffect, useState } from "react"
import { MixedMerchantDetails } from "swiipe.portal.shared"
import { getDigitealOnboardingEventsThunk, IDigitealOnboardingEvent } from "../../store/thunks/digitealThunks"
import useReduxDispatch from "../../store/useReduxDispatch"
import DigitealDetailsSection from "./DigitealDetailsSection"
import "./DigitealDetailsSectionWebhooks.scss"

interface IDigitealDetailsSectionWebhooks {
    merchantDetails: MixedMerchantDetails
}

const DigitealDetailsSectionWebhooks = ({ merchantDetails }: IDigitealDetailsSectionWebhooks) => {
    const dispatch = useReduxDispatch()

    const [onboardingEvents, setOnboardingEvents] = useState<IDigitealOnboardingEvent[] | null>(null)

    useEffect(() => {
        setOnboardingEvents(null)
        ;(async () => {
            const events = await dispatch(getDigitealOnboardingEventsThunk(merchantDetails.swMerchant.swMerchantId))
            setOnboardingEvents(events.onboardingEvents)
        })()
    }, [merchantDetails])

    return (
        <DigitealDetailsSection
            title="Webhook Events"
            description="Webhook events from Digiteal related to onboarding merchant."
            isLoading={onboardingEvents === null}
            sectionClassName="digiteal-webhooks"
        >
            <div className="digiteal-webhooks__panel">
                {!onboardingEvents || onboardingEvents.length == 0 ? (
                    <p className="digiteal-webhooks__text digiteal-webhooks__text--secondary">No webhook events found</p>
                ) : (
                    onboardingEvents.map((e, i) => {
                        return (
                            <div key={i} className="digiteal-webhooks__event">
                                <p className="digiteal-webhooks__text digiteal-webhooks__text--secondary">
                                    [{new Date(e.timestamp).toLocaleString()}]
                                </p>
                                <b className="digiteal-webhooks__text">{e.type || "unknown hook type"}:</b>
                                <p className="digiteal-webhooks__text">{e.content.changeType}</p>
                            </div>
                        )
                    })
                )}
            </div>
        </DigitealDetailsSection>
    )
}

export default DigitealDetailsSectionWebhooks
